import SDIcon from './SDIcon'

const IconCarbonBuilding = (props) => (
  <SDIcon title='Building' {...props}>
    <path d='M28,2H16a2.002,2.002,0,0,0-2,2V14H4a2.002,2.002,0,0,0-2,2V30H30V4A2.0023,2.0023,0,0,0,28,2ZM9,28V21h4v7Zm19,0H15V20a1,1,0,0,0-1-1H8a1,1,0,0,0-1,1v8H4V16H16V4H28Z' />
    <rect x='18' y='8' width='2' height='2' />
    <rect x='24' y='8' width='2' height='2' />
    <rect x='18' y='14' width='2' height='2' />
    <rect x='24' y='14' width='2' height='2' />
    <rect x='18' y='19.9996' width='2' height='2' />
    <rect x='24' y='19.9996' width='2' height='2' />
    <rect id='_Transparent_Rectangle_' data-name='&lt;Transparent Rectangle&gt;' />
  </SDIcon>
)

export default IconCarbonBuilding
